import React from "react";
import { DashboardContext } from "./DashboardLayout";
import { SubscriptionTab } from "./tabs/SubscriptionTab";

export const SubscriptionPage: React.FC = () => {
  // Get data from context
  const dashboardData = React.useContext(DashboardContext);
  if (!dashboardData) {
    throw new Error("SubscriptionPage must be used within DashboardLayout");
  }

  const { user, stats } = dashboardData;

  return <SubscriptionTab user={user} stats={stats} />;
};
